export default {"src":"/_next/static/media/hire.cb34d1dd.svg","height":316,"width":480,"blurWidth":0,"blurHeight":0};